import { render, staticRenderFns } from "./userFeebackList.vue?vue&type=template&id=551ad91f"
import script from "./userFeebackList.vue?vue&type=script&lang=js"
export * from "./userFeebackList.vue?vue&type=script&lang=js"
import style0 from "./userFeebackList.vue?vue&type=style&index=0&id=551ad91f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports